import { useNavigation } from "@react-navigation/native";
import * as ImagePicker from "expo-image-picker";
import { useCallback } from "react";
import { StyleSheet } from "react-native";

import { Button, Col, Col1, Content, Icon, Row, TextBody } from "../lib";
import { useUserImageIdentityStore } from "../services";
import { sizes } from "../theme";

export function VerifyIdentityScreen() {
  // Data
  const [storeUserImageIdentity, isUplopading] = useUserImageIdentityStore();

  // Vars
  const navigation = useNavigation();

  // Methods
  const uploadAsset = useCallback(
    async (asset: ImagePicker.ImagePickerAsset) => {
      await storeUserImageIdentity(asset);

      navigation.goBack();
    },
    [navigation, storeUserImageIdentity]
  );

  // Handlers
  const handleCamera = useCallback(async () => {
    const result = await ImagePicker.launchCameraAsync();

    if (!result.canceled) {
      await uploadAsset(result.assets[0]);
    }
  }, [uploadAsset]);

  const handleLibrary = useCallback(async () => {
    const result = await ImagePicker.launchImageLibraryAsync();

    if (!result.canceled) {
      await uploadAsset(result.assets[0]);
    }
  }, [uploadAsset]);

  // Render
  return (
    <Content>
      <Col.C my="6" px="4">
        <Icon name="fingerprint" large />
        <TextBody mt="4" em center>
          You are one step away from becoming a companion on Smooci
        </TextBody>
      </Col.C>
      <Col my="6" style={$.copy}>
        <TextBody>
          To use Smooci you have to verify your identity -{" "}
          <TextBody em>
            please upload your{" "}
            <TextBody em style={$.underline}>
              ID document or passport
            </TextBody>
          </TextBody>
        </TextBody>
        <TextBody>
          Please make sure that you upload a clear and readable photo.
        </TextBody>
        <TextBody>
          *Your ID is required to verify you are of legal age. It will never be
          shown on the smooci site, or to any client or third party
        </TextBody>
      </Col>

      <Row.LR mt="6" style={{ gap: sizes["2"] }}>
        <Col1>
          <Button
            icon="image-multiple-outline"
            loading={isUplopading}
            onPress={handleLibrary}
          >
            Upload ID
          </Button>
        </Col1>

        <Col1>
          <Button
            icon="camera-outline"
            loading={isUplopading}
            onPress={handleCamera}
          >
            Take photo
          </Button>
        </Col1>
      </Row.LR>
    </Content>
  );
}

const $ = StyleSheet.create({
  copy: {
    gap: sizes["4"],
  },
  bold: {
    fontWeight: "bold",
  },
  underline: {
    textDecorationLine: "underline",
  },
});
